module.exports = __webpack_public_path__ + "img/BlinkArt_Sword12_Purple.d4c93615.png";